import React from 'react';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';

const CACHE_TTL = 4 * 60 * 60 * 1000; // 4 hours - tags have not changed in 3 years

export default function useTags(type, options = {}) {
  const enabled = options.enabled || true;

  const tags = useConnect('tag.find', {
    pagination: {
      pageSize: 1000,
      order: 'name asc'
    }
  }, { cacheTime : CACHE_TTL * 2, staleTime: CACHE_TTL, refetchOnWindowFocus: false, enabled });

  return {
    state: tags.state,
    data: tags.data.filter(function(tag) {
      if (type) {
        return tag.data.type === type;
      }

      return true;
    })
  };
}
